import { EmailTemplateManager } from "../components/admin/EmailTemplateManager.js";

export function CmtsAdminNotificationsPage() {
  return <EmailTemplateManager />;
}

export default CmtsAdminNotificationsPage;
